import { Feature } from '@tencent/workbench';
import BaseToolbarFeature from '@framework/workbench/common/feature/base-toolbar-feature';
import { config } from './config';
import DUISnackbar from '@tencent/dui/lib/components/Snackbar';
import i18n from '@i18next/i18n';
import { MallType, PageType } from './types';
import { onSlideAppReady } from '@src/slide/domain/slide-app/core/slide-data-services.core';

export type OnOpenAddon = (addonId: string) => Promise<void>;

@Feature()
export class AddonMallFeature extends BaseToolbarFeature {
    config = config;
    private openAddonPanel;
    private closeAddonPanel;
    public constructor() {
        super();
        onSlideAppReady(() => {
            this.getAddonFunc();
        });
    }
    public async openAddonMall(onOpen: OnOpenAddon, type: MallType): Promise<void> {
        await this.getAddonFunc();
        const page = PageType[type] ?? 'index';
        this.openAddonPanel({
            page,
            type: 'slide',
            onOpenAddon: ({ id }) => {
                onOpen(id)
                    .then(this.closeAddonPanel)
                    .catch(() => {
                        DUISnackbar.show({
                            message: i18n.t('打开失败，请稍后重试。'),
                            type: 'error',
                            autoClose: true,
                        });
                    });
            },
        });
    }

    private getAddonFunc = async () => {
        if (this.openAddonPanel && this.closeAddonPanel) return;
        return import(/* webpackChunkName: "addon" */ '@tencent/docs-tmall-panel/dist/addon')
            .then((module) => {
                const { openAddonPanel, closeAddonPanel } = module;
                this.openAddonPanel = openAddonPanel;
                this.closeAddonPanel = closeAddonPanel;
            })
            .catch((error) => {
                window.log.error(`[loadChunk-error]${error}`);
            });
    };
}
